import React,{useState,useEffect} from 'react'
import "../styles/Home.css"
import  {db, auth } from "../firebase-config.js"
import { addDoc,collection,onSnapshot,serverTimestamp,query,where, orderBy} from 'firebase/firestore';
import Card from 'antd/es/card/Card';
import { Button,Input,Form } from 'antd';
function Home(props) {
  const {room,signOut}= props;
  const [message,setMessage] = useState("");
  const meesageRef = collection(db,"mesages");
  const [chat,setChat]= useState([])
  const handle = async(e)=>{
  e.preventDefault();
  console.log(message)

  if (message==="") return;
  await addDoc(meesageRef,{
    text:message || null,
    user: auth.currentUser.displayName || null,
    created:serverTimestamp(),
    room: room || null,


  });
  setMessage("");
  }

  useEffect(()=>{

    const queryMessages = query(meesageRef,where("room","==",room),orderBy("created"))

   const unsubscribe = onSnapshot(queryMessages,(snap)=>{
      let cmessages=[]
      snap.forEach((doc)=>{
   
      cmessages.push({...doc.data(),id:doc.id})
      
    });
    setChat(cmessages);
    });
    return() => unsubscribe();

  },[]);


  return (
    <Card 
    hoverable={true}
    style={{ display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",gap:"20px" } }
    > 
    <div className='chat' > Welcome to <h2>{room}</h2 > 
    <div className='chat-msg-l'> {chat.map((message)=>{ return <div className='chat-msg' key={message.id}>
      <span>{message.user} <img src="" alt=""></img></span> <p>{message.text} </p></div>})}</div>
    <form className = "new-message" onSubmit={handle}>
<Input className='message-input'
value={message}
onChange={(e)=>
  (setMessage(e.target.value))}
placeholder='Type your message here...'></Input>
<Button htmlType='submit' className="submit-msg"> Send </Button>
    </form>

    <Button onClick={signOut}> Sign Out</Button>
    
</div>
</Card>
  )
}

export default Home